
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { AudioDevice, AudioTypes } from "@/types/audio/audio";
import { namespace } from 'vuex-class';

const SMCameras = namespace("siteMonitorCameras");

@Component({})
export default class AudioList extends Vue {
    @Prop({default:"Devices"})
    private listTitle: string

    @Prop({default: []})
    private audioDevices!: AudioDevice[];

    @Prop({default: null})
    private selectedAudioDevice: AudioDevice | null;

    @Prop({default: false, type: Boolean})
    private isAreaAudioList!: boolean;

	@SMCameras.State("areaAudioDevicesCount")
	private areaAudioDevicesCount!: number;

    private open: boolean = false;
    private audioOptionTypes: any = AudioTypes;

	private get filteredAudioDevices(): AudioDevice[] {
        return this.audioDevices.filter(audio =>
            audio.canReceive || audio.canTransmit || audio.canTwoway
        );
    }

	private get showLoadMoreButton(): boolean {
		return this.isAreaAudioList && this.filteredAudioDevices.length > 0 && this.filteredAudioDevices.length < this.areaAudioDevicesCount;
	}

	public collapseAudioList(): void {
        this.open = false;
    }

    @Emit("set-selected-device")
    private setSelectedAudioDevice(audioDevice: AudioDevice | null): AudioDevice | null {
        return audioDevice;
    }

	private showMoreAudios(): void {
		this.$emit("load-more-audios");
	}
}
